module.exports = __webpack_public_path__ + "static/media/TelValidationSound.21d988dc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audios/TelValidationSound.mp3
// module id = 2605
// module chunks = 0